import React from "react";
import { IconProps } from "../icon";

export const ClockFastForwardIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M22.7 11.5l-2 2-2-2m2.245 1.5A9 9 0 1019 17.657M12 7v5l3 2"
    />
  </svg>
);
